<template>
  <div class="main" id="main_all">
    <div class="choose_year">
      <div class="icon" @click="chooseYears(-1)" style="cursor: pointer;"><i class="el-icon-d-arrow-left"></i></div>
      <div class="icon" @click="chooseMonth(-1)" style="cursor: pointer;"><i class="el-icon-arrow-left"></i></div>
      <!-- .padStart(2, '0') -->
      <div class="all_date">
        <el-select v-model="year" placeholder="" @change="changeYear">
          <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
        <div class="date">年 {{ month.toString() }} 月</div>
      </div>
      <div class="icon" @click="chooseMonth(1)" style="cursor: pointer;"><i class="el-icon-arrow-right"></i></div>
      <div class="icon" @click="chooseYears(1)" style="cursor: pointer;"><i class="el-icon-d-arrow-right"></i></div>
    </div>
    <div class="days_area">
      <div class="day week" v-for="week in weeks" :key="week">{{ week }}</div>
      <div class="day" @click="chooseThisDay(day)" v-for="(day, index) in days" :key="index"
        :class="(day.gregorian === today && clickYear == year && clickMonth == month) ? 'choose_day' : ''"
        :style="day.canClick ? 'cursor: pointer;' : 'cursor: not-allowed;color:#C0C4CC;'">
        <p>{{ day.gregorian }} </p>
        <span>{{ day.IDayCn == "初一" ? day.IMonthCn : day.IDayCn }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import calendar from '@/utils/calendar'
const thisYear = 2100;
const dafaultYearArr = [];
for (let i = 1901; i <= thisYear; i++) {
  let item = { name: i, value: i };
  dafaultYearArr.push(item);
}
export default {
  props: ['chocieDay', 'nowDay'],
  name: 'datePick',
  data() {
    return {
      year: 0,
      month: 0,
      today: 0,
      days: [],
      weeks: ['一', '二', '三', '四', '五', '六', '日'],
      clickYear: 0,
      clickMonth: 0,
      options: dafaultYearArr
    }
  },
  mounted() {
    // 禁用选择
    let mianAll = document.getElementById("main_all");
    mianAll.onselectstart = new Function("event.returnValue=false");
    const now = new Date()
    if (this.chocieDay != undefined && this.chocieDay != '') {
      this.year = parseInt(this.chocieDay.substring(0, 4))
      this.month = parseInt(this.chocieDay.substring(5, 7)) >= 10 ?
        parseInt(this.chocieDay.substring(5, 7)) : parseInt(this.chocieDay.substring(6, 7))
      this.today = parseInt(this.chocieDay.substring(8, 10)) >= 10 ?
        parseInt(this.chocieDay.substring(8, 10)) : parseInt(this.chocieDay.substring(9, 10))
      this.clickYear = parseInt(this.chocieDay.substring(0, 4))
      this.clickMonth = parseInt(this.chocieDay.substring(5, 7)) >= 10 ?
        parseInt(this.chocieDay.substring(5, 7)) : parseInt(this.chocieDay.substring(6, 7))
    } else {
      this.year = now.getFullYear()
      this.month = now.getMonth() + 1
      this.today = now.getDate()
      this.clickYear = now.getFullYear()
      this.clickMonth = now.getMonth() + 1
    }
    this.getDays()

  },
  methods: {
    getDays() { // 获取当前月份所有公历日期及其农历日期
      this.days = []
      const day = new Date()
      day.setFullYear(this.year, this.month - 1, 1) // 此处较之前调整，获取当月第一天
      const month = new Date()
      month.setFullYear(this.year, this.month, 0) // 此处较之前调整，获取当月
      for (let i = 1; i < day.getDay(); i++) { // 当月第一天距离所在周周一的空白占位
        this.days.push({ gregorian: '', IDayCn: '', IMonthCn: '', lDay: '', lMonth: '' })
      }
      for (let i = 1; i <= month.getDate(); i++) { // 获取当月天数填充日历
        let lunarCalendar = calendar.solar2lunar(this.year, this.month, i);
        // console.log(lunarCalendar)
        let dateString = this.year + '-' + (this.month >= 10 ? this.month : '0' + this.month) + '-' + (i >= 10 ? i : '0' + i)
        let date = new Date(dateString)
        if (dateString == this.nowDay) {
          this.days.push({
            //这里我只拿了我要的几个数据,你可以根据自己需要处理 ,lunarCalendar 数据很全
            gregorian: i,
            IDayCn: lunarCalendar.IDayCn,//初几等
            IMonthCn: lunarCalendar.IMonthCn,//正月等
            lDay: lunarCalendar.lDay,//农历日号
            lMonth: lunarCalendar.lMonth,//农历月号
            lYear: lunarCalendar.gzYear,
            Animal: lunarCalendar.Animal,
            canClick: (date.getTime() < new Date(Date.parse("1901-01-01".replace(/-/g, "/")))) ? false : true
          })
        } else {
          this.days.push({
            //这里我只拿了我要的几个数据,你可以根据自己需要处理 ,lunarCalendar 数据很全
            gregorian: i,
            IDayCn: lunarCalendar.IDayCn,//初几等
            IMonthCn: lunarCalendar.IMonthCn,//正月等
            lDay: lunarCalendar.lDay,//农历日号
            lMonth: lunarCalendar.lMonth,//农历月号
            lYear: lunarCalendar.gzYear,
            Animal: lunarCalendar.Animal,
            canClick: (date.getTime() > Date.now() || date.getTime() < new Date(Date.parse("1901-01-01".replace(/-/g, "/")))) ? false : true
          })
        }
      }
    },
    dateTransition(month, day) {
      month = month >= 10 ? month : '0' + month;
      day = day >= 10 ? day : '0' + day;
      return [month, day].join('');
    },
    chooseYears(state) { // 改变年份
      if (this.year <= 1901 && state != 1) {
        return
      }
      if (this.year >= 2100 && state != -1) {
        return
      }
      this.year += state
      //this.today = 1
      this.getDays()
    },
    changeYear(e) {
      this.year = e;
      this.getDays()
    },
    chooseMonth(state) { // 改变月份
      if (this.year <= 1901 && state != 1 && this.month == 1) {
        return
      }
      if (this.year >= 2100 && state != -1 && this.month == 12) {
        return
      }
      this.month += state
      //this.today = 1
      if (this.month < 1) {
        this.month = 12
        this.chooseYears(-1)
      } else if (this.month > 12) {
        this.month = 1
        this.chooseYears(1)
      } else {
        this.getDays()
      }
    },
    //这里是我要的数据处理, 你用的时候可以根据自己需要做更改
    chooseThisDay(days) { // 选择某天
      // let dateString = this.year + '-'+ 
      // (this.month>=10 ? this.month : '0'+ this.month) +'-'+ 
      // (days.gregorian>=10 ? days.gregorian : '0'+days.gregorian)
      // let date = new Date(dateString)
      // if(date.getTime() > Date.now()){
      //   return
      // }
      if (!days.canClick) {
        return
      }
      this.clickYear = this.year
      this.clickMonth = this.month
      let year = this.year
      let month = this.month
      let day = days.gregorian
      let Animal = days.Animal
      if (days.gregorian > 0) {
        this.today = days.gregorian
      }
      let lYear = days.lYear
      let arr = this.dateTransition(days.lMonth, days.lDay);
      let { IDayCn, IMonthCn } = days
      let data = {
        IDayCn, IMonthCn, arr, year, month, day, lYear, Animal
      }
      //把 处理好的数据 抛给父组件(即调用此组件的父组件)
      this.$emit('updateLunar', data);
    }
  }
}
</script>
  
<style lang='stylus' scoped>
  .main{

    .all_date{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 60%;
    }

    .all_date .el-select {
      width: 100px;
    }

    .choose_year{
      display: flex;
      .icon{
        width: 10%;
        height: 80px;
        line-height: 80px;
        text-align: center;
      }
      .date{
        // width: 60%;
        margin-left: 10px;
        text-align: center;
        height: 80px;
        line-height: 80px;
        font-size: 16px;
      }
    }
    .days_area{
      display: flex;
      flex-wrap: wrap;
      .day{
        width: 14.28%;
        text-align: center;
        padding: 10px 0;
        margin-top: 10px;
        p{
          margin: 0;
          font-size: 14px;
        }
        span{
          font-size: 14px;
        }
      }
      .week{
        background-color: dodgerblue;
        color: #fff;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        margin: 0;
      }
      .choose_day{
        background-color: dodgerblue;
        color: #fff;
        font-weight: bold;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/datePick.vue